module.exports = __webpack_public_path__ + "img/ocp_xpsgametoken.5312d19.png";